import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'components/ui/chip/Chip';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchCategoryAccumulated } from 'store/actions/categories/fetchCategories';

class Category extends React.Component {
    componentDidMount() {
        if (utils.has(this.props, 'record.category_id')) {
            this.props.fetchCategoryAccumulated({
                id: this.props.record.category_id,
            });
        }
    }

    render() {
        const { category } = this.props;

        if (!category) {
            return null;
        }

        return (
            <Chip>{ category.name }</Chip>
        );
    }
}

Category.propTypes = {
    fetchCategoryAccumulated: PropTypes.func.isRequired,
    category: PropTypes.object,
    record: PropTypes.object,
};

export default connect(
    (state, props) => {
        const resourceState = state[props.reference];
        const record = props.record;

        if (record && record.hasOwnProperty('category_id')) {
            return {
                category: resourceState.data[record.category_id],
            };
        }
    },
    {
        fetchCategoryAccumulated: fetchCategoryAccumulated,
    },
)(Category);



// WEBPACK FOOTER //
// ./src/components/field/CategoryField.js